import _ from "lodash";
import QueryDepartments from "graphql/queries/QueryDepartments";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

const FetchDepartment = {
	
	fetchAll: ({ callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'departments', QueryDepartments, {
			variables,
			resultPath: [ 'departments' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						departments: result
					});
				}
			}
		})
	}
}

export default FetchDepartment
